import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useAppSelector } from "../../../../../../../../store/config";
import { notification } from "antd";
import { useEffect, useState } from "react";

import TrainingProgramWorkoutDetails from "../../../trainingPrograms/training-program/workouts/TrainingProgramWorkoutDetails";
import SingleWorkoutDetails from "./SingleWorkoutDetails";

export const WorkoutDetails = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { type, isEdit } = location.state || {};
  const navigate = useNavigate();

  const { trainingProgramId } = useParams<{ trainingProgramId: string }>();
  const { id: trainerId } = useParams<{ id: string }>();
  const [api, contextHolder] = notification.useNotification();
  const isNew: boolean = location.pathname.includes("/workouts/add");

  const [isEditable, setIsEditable] = useState(false);

  const { workout, loading, error, requestState, operation } = useAppSelector(
    (state) => state.workout
  );

  useEffect(() => {
    if (isNew || isEdit) setIsEditable(true);
  }, [isNew]);

  useEffect(() => {
    if (requestState === "finish") {
      if (operation === "update" || operation === "create") {
        setIsEditable(false);
      }
      if (operation === "create" && workout?._id) {
        let navigateTo = `/trainers/${trainerId}/workouts/${workout._id}`;
        if (trainingProgramId) {
          navigateTo = `/trainers/${trainerId}/training-programs/${trainingProgramId}/workouts/${workout._id}`;
        }
        navigate(navigateTo, { replace: true });
      }
    }
  }, [requestState, operation, workout, navigate, trainerId]);

  useEffect(() => {
    if (error) {
      const specificError =
        error.message === "Index already occupied in training program"
          ? t("Cannot schedule on this day as there is already a workout")
          : undefined;
      openNotification(specificError);
    }
  }, [error]);

  const openNotification = (error?: string) => {
    api["error"]({
      message: t(error || "Something went wrong, please try again"),
      placement: "bottomLeft",
    });
  };

  return (
    <>
      {contextHolder}
      {trainingProgramId ? (
        <TrainingProgramWorkoutDetails
          isEditable={isEditable}
          setIsEditable={setIsEditable}
          workout={workout}
          loading={loading}
          isNew={isNew}
          openNotification={openNotification}
          type={type}
        />
      ) : (
        <SingleWorkoutDetails
          isEditable={isEditable}
          setIsEditable={setIsEditable}
          workout={workout}
          loading={loading}
          isNew={isNew}
          type={type}
        />
      )}
    </>
  );
};
